import React from 'react'
import { GoogleLogin, CredentialResponse } from '@react-oauth/google'
import { useAuth } from '../context/AuthContext'
import { signInWithMicrosoft } from '../utils/microsoftAuth'

const Login: React.FC = () => {
  const { loginWithCredential, isUserDirectoryLoading } = useAuth()
  const [error, setError] = React.useState<string | null>(null)
  const [isMicrosoftSigningIn, setIsMicrosoftSigningIn] = React.useState(false)

  const handleSuccess = (credentialResponse: CredentialResponse) => {
    if (credentialResponse.credential) {
      loginWithCredential(credentialResponse.credential)
      setError(null)
    } else {
      const message = 'Google did not return a credential. Please try again.'
      console.error(message, credentialResponse)
      setError(message)
    }
  }

  const handleError = () => {
    const message = 'Unable to sign in with Google. Please try again or contact support.'
    console.error(message)
    setError(message)
  }

  const handleMicrosoftLogin = async () => {
    try {
      setIsMicrosoftSigningIn(true)
      const credential = await signInWithMicrosoft()
      if (!credential) {
        const message = 'Microsoft did not return a credential. Please try again.'
        console.error(message)
        setError(message)
        return
      }

      loginWithCredential(credential)
      setError(null)
    } catch (err) {
      console.error('Unable to sign in with Microsoft', err)
      setError('Unable to sign in with Microsoft. Please try again or contact support.')
    } finally {
      setIsMicrosoftSigningIn(false)
    }
  }

  return (
    <div className="container" style={{ maxWidth: '460px', textAlign: 'center', padding: '3rem 1rem' }}>
      <h1 style={{ marginBottom: '1rem', color: 'var(--primary-color)' }}>Sign in to continue</h1>
      <p style={{ marginBottom: '2rem', color: '#666' }}>
        Use your Google account to access the Christmas Wish List app.
      </p>
      <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', gap: '0.75rem' }}>
        <GoogleLogin onSuccess={handleSuccess} onError={handleError} useOneTap={false} />
        <button
          type="button"
          onClick={handleMicrosoftLogin}
          disabled={isMicrosoftSigningIn}
          style={{
            border: '1px solid #dfe1e5',
            background: '#fff',
            color: '#2f2f2f',
            borderRadius: '4px',
            padding: '0.75rem 1rem',
            cursor: isMicrosoftSigningIn ? 'not-allowed' : 'pointer',
            fontWeight: 600
          }}
        >
          {isMicrosoftSigningIn ? 'Signing in...' : 'Sign in with Microsoft'}
        </button>
      </div>
      {isUserDirectoryLoading && (
        <p style={{ marginTop: '1.25rem', color: 'var(--primary-color)', fontWeight: 600 }}>
          Loading family data...
        </p>
      )}
      {error && (
        <p style={{ marginTop: '1.5rem', color: 'var(--danger-color, #c0392b)', fontWeight: 600 }}>
          {error}
        </p>
      )}
    </div>
  )
}

export default Login
